import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { Widget, Button, Table } from '@digital/ui';
import { useRecoilValue } from 'recoil';

import { getDadosGerais, OrdemCompraDadosGerais } from '@app/api/sas/ordemCompra';
import { getAcoesFornecedor } from '@app/api/sas/sasFornecedor';

import {
  dadosGeraisState,
  ordemCompraIdState,
  stepState,
} from '../atoms';

import ModalAcaoFornecedor from './ModalAcaoFornecedor';

import { IAcaoFornecedor } from '@app/api/sas/sasDocumentoOrdemCompra';
const { Panel } = Collapse;

const WidgetAcoesFornecedor = () => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const ordemCompra = useRecoilValue(dadosGeraisState);

  const [acoes, setAcoes] = useState<IAcaoFornecedor[]>([]);
  const [updateAcoes, setUpdateAcoes] = useState<boolean>(false);

  const [acaoSelecionada, setAcaoSelecionada] = useState<IAcaoFornecedor | null>(null);

  useEffect(() => {
    if (!ordemCompraId) return;
    setAcoes([]);
    getAcoesFornecedor(ordemCompraId).then(r => r.acoes && setAcoes(r.acoes));
  }, [updateAcoes]);



  const atualizaTela = (acaoId: string) => {
    setUpdateAcoes(true);
    //setAcoes(prev => prev.filter(a => a.id !== acaoId));
  };

  const columns = (): ColumnProps<any>[] => [
    { title: 'Ação', dataIndex: 'acao' },
    { title: 'Descrição', dataIndex: 'descricao' },

    {
      title: 'Ação',
      width: '5%',
      render: (_, record: IAcaoFornecedor) => (
        <Tooltip title="Executar ação">
          <Button
            icon="arrows-chevron_right"
            onClick={() => setAcaoSelecionada(record)}
            disabled={record.statusAcao !== 'Pendente'}
          />
        </Tooltip>
      )
    },
    
    {
      title: 'Status',
      render: (_, record: IAcaoFornecedor) => {
        if (!record.statusAcao) return '-';
        const statusAcao = record.statusAcao;
        return <span
          style={{
            color: statusAcao === 'Pendente' ? '#fa8c16' : undefined,
            fontWeight: statusAcao === 'Pendente' ? 500 : undefined,
          }}
        >
          {statusAcao}
        </span>
      },
      dataIndex: 'statusAcao'
    },
    { title: 'Data limite', width: '12%', dataIndex: 'dataLimite' , render: (v) => v ? new Date(v).toLocaleDateString() : "-"},
    { title: 'Data Execução', width: '12%', dataIndex: 'dataExecucao' , render: (v) => v ? new Date(v).toLocaleDateString() : "-"},
  ];

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['documentacao']}
        expandIcon={() => <Icon type="arrows-right_4" />}
      >
        <Panel
          key="documentacao"
          header={`Ações do Fornecedor - OC ${ordemCompra && ordemCompra.numero || ''}`}
        >
          <Widget>
            <Table dataSource={acoes} columns={columns()} pagination={false} />
          </Widget>
        </Panel>
      </Collapse>

      {acaoSelecionada && (
        <ModalAcaoFornecedor
          visible
          acao={acaoSelecionada}
          ordemCompraId={ordemCompraId}
          onSuccess={() => atualizaTela(acaoSelecionada.id)}
          onClose={() => setAcaoSelecionada(null)}
        />
      )}
    </>
  );
};

export default WidgetAcoesFornecedor;
